export class SimpleTabs extends HTMLElement {
  connectedCallback() {
    const buttons = this.querySelectorAll('.js-simple-tabs-button');
    const contents = this.querySelectorAll('.js-simple-tabs-content');

    buttons?.forEach((btn, index) => {
      btn?.addEventListener('click', () => {
        buttons.forEach(b => b.setAttribute('aria-expanded', 'false'));
        contents?.forEach(p => p?.setAttribute('aria-hidden', 'true'));
        btn.setAttribute('aria-expanded', 'true');
        contents[index].setAttribute('aria-hidden', 'false');
      });
    });
  }

}

document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('simple-tabs')) {
    customElements.define('simple-tabs', SimpleTabs);
  }
})